import apiClient from "../../../http-common";


//Listing Api
// export const EmployeeListing = (saveObj) => {
//   return country.post(`/employee/employeeList`, saveObj, {
//     headers: {
//       authorization:
//         "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJNciBOaWxlc2ggU2hpbmRlIiwiZW1wSWQiOjY4LCJlbXBsb3llZVR5cGUiOiJIb3VzZWtlZXBpbmcgSW5jaGFyZ2UiLCJjcmVhdGVkIjoxNjkyNjc2NjU3Nzc2LCJleHAiOjI3NzI2NzY2NTcsInVzZXIiOjE1NCwic3RhdHVzIjp0cnVlLCJ1c2VybmFtZSI6Ik1yIE5pbGVzaCBTaGluZGUifQ.jgfQKryiLdGRm1cHZ8HzJo9fGST-0VRxFDoFzqc_n2gwb_SaE606BNURAAneU4aItK_7ZT0obrslPtFvxsBIMw",
//       Accept: "application/json",
//       "Content-Type": "application/json",
//     },
//   })
// }

export const EmployeeListing = (saveObj) => {
  return apiClient.post(`/employeeMaster/EmployeeMasterList`, saveObj)
}

// Autosearch API
// export const EmployeeSearch = (searchString) => {
//   return country.get(`/employee/employeeMasterListSearch/${searchString}`,
//     {
//       headers: {
//         authorization:
//           "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJNciBOaWxlc2ggU2hpbmRlIiwiZW1wSWQiOjY4LCJlbXBsb3llZVR5cGUiOiJIb3VzZWtlZXBpbmcgSW5jaGFyZ2UiLCJjcmVhdGVkIjoxNjkyNjc2NjU3Nzc2LCJleHAiOjI3NzI2NzY2NTcsInVzZXIiOjE1NCwic3RhdHVzIjp0cnVlLCJ1c2VybmFtZSI6Ik1yIE5pbGVzaCBTaGluZGUifQ.jgfQKryiLdGRm1cHZ8HzJo9fGST-0VRxFDoFzqc_n2gwb_SaE606BNURAAneU4aItK_7ZT0obrslPtFvxsBIMw",
//         Accept: "application/json",
//         "Content-Type": "application/json",
//       },
//     })
// };

export const EmployeeSearch = (searchStr) => {
  return apiClient.post(`/dropdowns/getEmployeeDropDown/${searchStr}`);
}


//Classification Dropdown
// export const EmpclassificationDropdown = () => {
//   return country.get(`/employee/employeeClassification`, {
//     headers: {
//       authorization:
//         "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJNciBOaWxlc2ggU2hpbmRlIiwiZW1wSWQiOjY4LCJlbXBsb3llZVR5cGUiOiJIb3VzZWtlZXBpbmcgSW5jaGFyZ2UiLCJjcmVhdGVkIjoxNjkyNjc2NjU3Nzc2LCJleHAiOjI3NzI2NzY2NTcsInVzZXIiOjE1NCwic3RhdHVzIjp0cnVlLCJ1c2VybmFtZSI6Ik1yIE5pbGVzaCBTaGluZGUifQ.jgfQKryiLdGRm1cHZ8HzJo9fGST-0VRxFDoFzqc_n2gwb_SaE606BNURAAneU4aItK_7ZT0obrslPtFvxsBIMw",
//       Accept: "application/json",
//       "Content-Type": "application/json",
//     },});
// };

export const EmpclassificationDropdown = () => {
  return apiClient.post(`/dropdowns/getClassificationDropDown`,)
}


//Category Dropdown 
export const EmpcategoryDropdown = (classificationId) => {
  return apiClient.get(`/employee/employeeCategory/${classificationId}`, {
    headers: {
      authorization:
        "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJNciBOaWxlc2ggU2hpbmRlIiwiZW1wSWQiOjY4LCJlbXBsb3llZVR5cGUiOiJIb3VzZWtlZXBpbmcgSW5jaGFyZ2UiLCJjcmVhdGVkIjoxNjkyNjc2NjU3Nzc2LCJleHAiOjI3NzI2NzY2NTcsInVzZXIiOjE1NCwic3RhdHVzIjp0cnVlLCJ1c2VybmFtZSI6Ik1yIE5pbGVzaCBTaGluZGUifQ.jgfQKryiLdGRm1cHZ8HzJo9fGST-0VRxFDoFzqc_n2gwb_SaE606BNURAAneU4aItK_7ZT0obrslPtFvxsBIMw",
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};


//Post Object API
// export const postEmployee = (saveObj) => {
//   return country.post(`/employee/createEmployee`, saveObj, {
//     headers: {
//       authorization:
//         "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJNciBOaWxlc2ggU2hpbmRlIiwiZW1wSWQiOjY4LCJlbXBsb3llZVR5cGUiOiJIb3VzZWtlZXBpbmcgSW5jaGFyZ2UiLCJjcmVhdGVkIjoxNjkyNjc2NjU3Nzc2LCJleHAiOjI3NzI2NzY2NTcsInVzZXIiOjE1NCwic3RhdHVzIjp0cnVlLCJ1c2VybmFtZSI6Ik1yIE5pbGVzaCBTaGluZGUifQ.jgfQKryiLdGRm1cHZ8HzJo9fGST-0VRxFDoFzqc_n2gwb_SaE606BNURAAneU4aItK_7ZT0obrslPtFvxsBIMw",
//       Accept: "application/json",
//       "Content-Type": "application/json",
//     },
//   });
// };


export const postEmployee = (saveObj) => {
  return apiClient.post(`/employeeMaster/saveOrUpdate`, saveObj)
}


// FindById API
// export const employeeFindById = (employeeId) => {
//   return country.get(`/employee/employeeMasterDetails/${employeeId}`, {
//     headers: {
//       authorization:
//         "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJNciBOaWxlc2ggU2hpbmRlIiwiZW1wSWQiOjY4LCJlbXBsb3llZVR5cGUiOiJIb3VzZWtlZXBpbmcgSW5jaGFyZ2UiLCJjcmVhdGVkIjoxNjkyNjc2NjU3Nzc2LCJleHAiOjI3NzI2NzY2NTcsInVzZXIiOjE1NCwic3RhdHVzIjp0cnVlLCJ1c2VybmFtZSI6Ik1yIE5pbGVzaCBTaGluZGUifQ.jgfQKryiLdGRm1cHZ8HzJo9fGST-0VRxFDoFzqc_n2gwb_SaE606BNURAAneU4aItK_7ZT0obrslPtFvxsBIMw",
//       Accept: "application/json",
//       "Content-Type": "application/json",
//     },
//   });
// };


export const employeeFindById = (id) => {
  return apiClient.get(`/employeeMaster/EmployeeEditView/${id}`);
}

// Autosearch API
export const doctorSearchDropDown = (searchString) => {
  return apiClient.get(`/employee/doctorSearch/${searchString}`,
    {
      headers: {
        authorization:
          "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJNciBOaWxlc2ggU2hpbmRlIiwiZW1wSWQiOjY4LCJlbXBsb3llZVR5cGUiOiJIb3VzZWtlZXBpbmcgSW5jaGFyZ2UiLCJjcmVhdGVkIjoxNjkyNjc2NjU3Nzc2LCJleHAiOjI3NzI2NzY2NTcsInVzZXIiOjE1NCwic3RhdHVzIjp0cnVlLCJ1c2VybmFtZSI6Ik1yIE5pbGVzaCBTaGluZGUifQ.jgfQKryiLdGRm1cHZ8HzJo9fGST-0VRxFDoFzqc_n2gwb_SaE606BNURAAneU4aItK_7ZT0obrslPtFvxsBIMw",
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
};

// FindById API
export const getDoctorDetail = (doctorId) => {
  return apiClient.get(`/employee/doctorDetails/${doctorId}`, {
    headers: {
      authorization:
        "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJNciBOaWxlc2ggU2hpbmRlIiwiZW1wSWQiOjY4LCJlbXBsb3llZVR5cGUiOiJIb3VzZWtlZXBpbmcgSW5jaGFyZ2UiLCJjcmVhdGVkIjoxNjkyNjc2NjU3Nzc2LCJleHAiOjI3NzI2NzY2NTcsInVzZXIiOjE1NCwic3RhdHVzIjp0cnVlLCJ1c2VybmFtZSI6Ik1yIE5pbGVzaCBTaGluZGUifQ.jgfQKryiLdGRm1cHZ8HzJo9fGST-0VRxFDoFzqc_n2gwb_SaE606BNURAAneU4aItK_7ZT0obrslPtFvxsBIMw",
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};

// export const getBirthDateAPI = (ageId, DOB) => {
//   return country.get(`/misc/${ageId}/${DOB}`, {
//     headers: {
//       authorization:
//         "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJNciBOaWxlc2ggU2hpbmRlIiwiZW1wSWQiOjY4LCJlbXBsb3llZVR5cGUiOiJIb3VzZWtlZXBpbmcgSW5jaGFyZ2UiLCJjcmVhdGVkIjoxNjkyNjc2NjU3Nzc2LCJleHAiOjI3NzI2NzY2NTcsInVzZXIiOjE1NCwic3RhdHVzIjp0cnVlLCJ1c2VybmFtZSI6Ik1yIE5pbGVzaCBTaGluZGUifQ.jgfQKryiLdGRm1cHZ8HzJo9fGST-0VRxFDoFzqc_n2gwb_SaE606BNURAAneU4aItK_7ZT0obrslPtFvxsBIMw",
//       Accept: "application/json",
//       "Content-Type": "application/json",
//     },
//   });
// };

export const getBirthDateAPI = (ageId, DOB) => {
  return apiClient.get(`/employeeMaster/calculateAge/${DOB}`);
}

export const updateStatusAPI = (empId, status) => {
  return apiClient.get(`/employee/updateEmployeeStatus/${empId}/${status}`, {
    headers: {
      authorization:
        "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJNciBOaWxlc2ggU2hpbmRlIiwiZW1wSWQiOjY4LCJlbXBsb3llZVR5cGUiOiJIb3VzZWtlZXBpbmcgSW5jaGFyZ2UiLCJjcmVhdGVkIjoxNjkyNjc2NjU3Nzc2LCJleHAiOjI3NzI2NzY2NTcsInVzZXIiOjE1NCwic3RhdHVzIjp0cnVlLCJ1c2VybmFtZSI6Ik1yIE5pbGVzaCBTaGluZGUifQ.jgfQKryiLdGRm1cHZ8HzJo9fGST-0VRxFDoFzqc_n2gwb_SaE606BNURAAneU4aItK_7ZT0obrslPtFvxsBIMw",
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};

